import { CreateFocusCss } from '../../../../styles'
import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    Heading: {
      margin: 0,

      link: {
        background: 'none',
        border: 'none',
        borderRadius: 0,
        color: 'inherit',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        lineHeight: 'inherit',
        padding: 0,
        margin: 0,
        textAlign: 'inherit',
        textDecoration: 'none',

        '&:active': {
          color: 'inherit',
        },

        ...CreateFocusCss(tokens.focusOuter),
      },

      linkCursor: {
        cursor: 'pointer',
        textTransform: 'inherit',

        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },

    'heading-xxs': {
      ...tokens.fontHeadingXXS,
    },

    'heading-xs': {
      ...tokens.fontHeadingXS,
    },

    'heading-s': {
      ...tokens.fontHeadingS,
    },

    'heading-m': {
      ...tokens.fontHeadingS,
    },

    'heading-l': {
      ...tokens.fontHeadingM,
    },

    'heading-xl': {
      ...tokens.fontHeadingM,
    },

    'display-xs': {
      ...tokens.fontDisplayXS,
    },

    'display-s': {
      ...tokens.fontDisplayS,
    },

    'display-m': {
      ...tokens.fontDisplayM,
    },

    'display-l': {
      ...tokens.fontDisplayL,
    },

    'section-headline': {
      ...tokens.fontSectionHeadline,
    },

    'body-m': {
      ...tokens.fontBodyM,
    },
  } as const
}
